import React from 'react';
import PropTypes from 'prop-types';
import ReactPlaceholder from 'react-placeholder';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	makeStyles,
	Grid
} from '@material-ui/core';

import NumberFormatter from '../utils/NumberFormatter';

const styles = makeStyles(theme => ({
	panel: {
		display: "inline-block",
		minWidth: theme.spacing(11),
		paddingTop: theme.spacing(0.5),
		paddingLeft: theme.spacing(2.5),
		paddingRight: theme.spacing(2.5),
		"& *": {
			color: `${theme.palette.common.white} !important`
		},

		"& p": {
			fontSize: "1.5rem",
			fontWeight: 200
		}
	},

	title: {
		paddingRight: theme.spacing(0.5)
	},

	value: {
		fontSize: "1.3rem"
	},

	selector: {
		borderRadius: 8,
		backgroundColor: theme.palette.primary.lightCyan,
		padding: '6px 12px',
		marginLeft: theme.spacing(0.5)
	},

	chevron: {
		fontSize: "1rem",
		marginLeft: theme.spacing(0.5)
	},

	green: {
		"& *": {
			color: `${theme.palette.secondary.green} !important`
		}
	},

	orange: {
		"& *": {
			color: `${theme.palette.secondary.orange} !important`
		}
	},

	grey: {
		"& *": {
			color: `${theme.palette.secondary.grey[500]} !important`
		}
	}
}));

function MetricsHeaderBarPanel(props) {
	const numFormatter = new Intl.NumberFormat("en-US", {maximumFractionDigits: 0});

	const getChangeColor = (positiveChange, classes) => {
		let color;
		if (positiveChange) {
			color = classes.green;
		} else if (positiveChange === false) {
			color = classes.orange;
		} else {
			color = classes.grey;
		}
		return color;
	};

	let classes = styles(),
		{className, title, value, change, excludeChevron, largeNumber, selector} = props,
		positiveChange = change > 0 ? true : change < 0 ? false : null,
		changeColor = getChangeColor(positiveChange, classes),
		icon = positiveChange === null ? "minus-circle" : `arrow-circle-${positiveChange ? 'up' : 'down'}`;

	if (typeof value === 'number') {
		if (largeNumber) {
			value = NumberFormatter.largeNumberFormat(value);
		} else {
			value = numFormatter.format(value);
		}
	}

	return (
		<div
			aria-label={title}
			aria-hidden="false"
			className={`${classes.panel} ${className}`}>
			<ReactPlaceholder
				type='textRow'
				ready={value != null || selector != null}
				style={{width: "85%", height: "0.7em", marginTop: 0}}>
				<Grid container alignItems='center'>
					<Grid item className={classes.title} >
						{title}
					</Grid>
					{value ? 
						<Grid item className={classes.value}>
							{value}
						</Grid> : null
					}
					{selector ?
						<Grid item className={classes.selector}>
							{selector}
						</Grid> : null
					}
					{!excludeChevron ?
						<Grid item>
							<FontAwesomeIcon
								icon={["far", icon]}
								className={`${changeColor} ${classes.chevron}`}
								title={`${positiveChange ? "upward change" : positiveChange === false ? "downward change" : "no change"}`} />
						</Grid> : null
					}
				</Grid>		
			</ReactPlaceholder>
		</div>
	);
}

MetricsHeaderBarPanel.defaultProps = {
	excludeChevron: false,
	largeNumber: false
};

MetricsHeaderBarPanel.propTypes = {
	className: PropTypes.string,
	title: PropTypes.string,
	change: PropTypes.number,
	invertChevron: PropTypes.bool,
	excludeChevron: PropTypes.bool,
	largeNumber: PropTypes.bool,
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	selector: PropTypes.any
};

export default MetricsHeaderBarPanel;